module.exports = __webpack_public_path__ + "img/the-times.857e240.svg";